export default "__VITE_ASSET__DMYblvcH__"